/* HØLY · holy-reels-modal — owned fullscreen vertical-swipe reels.
   No Swiper dependency: CSS scroll-snap (vertical) + IntersectionObserver play.
   Opens when a reel is tapped inside a <div class="holy-reels" data-fullscreen="true">.
   Skips Swiper loop-clones (.swiper-slide-duplicate); maps clicks by data-block-id. */
(function () {
  "use strict";
  var OPEN = "holy-reels-modal-open";

  // Reuse the theme's icon set (rendered into <template> by the section) — don't invent SVGs.
  function icon(name) {
    var t = document.querySelector('.holy-reels__ic[data-ic="' + name + '"]');
    return t ? t.innerHTML : "";
  }

  function originals(section) {
    return Array.prototype.filter.call(
      section.querySelectorAll(".holy-reels__card"),
      function (c) { return !c.classList.contains("swiper-slide-duplicate"); }
    );
  }

  function slideData(card) {
    var v = card.querySelector("video");
    var src = "";
    if (v) {
      var s = v.querySelector("source");
      src = (s && s.src) || v.currentSrc || v.getAttribute("src") || "";
    }
    var prod = card.querySelector(".holy-film__product");
    return { id: card.getAttribute("data-block-id") || "", src: src, cardHTML: prod ? prod.outerHTML : "" };
  }

  function buildSlides(section) {
    return originals(section).map(slideData).filter(function (s) { return s.src; });
  }

  function openModal(slides, startIndex) {
    var overlay = document.createElement("div");
    overlay.className = "holy-reels-modal";
    overlay.innerHTML =
      '<button class="holy-reels-modal__close" type="button" aria-label="Close"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M6 6L18 18M18 6L6 18" stroke="#F4EFE6" stroke-width="2" stroke-linecap="round"/></svg></button>' +
      '<div class="holy-reels-modal__track">' +
      slides.map(function (s) {
        return '<div class="holy-reels-modal__slide">' +
            '<video class="holy-reels-modal__video" src="' + s.src + '" autoplay loop muted playsinline preload="auto"></video>' +
            '<div class="holy-reels-modal__progress"><i></i></div>' +
            '<button class="holy-reels-modal__sound" type="button" data-sound="off" aria-label="Toggle sound">' + icon("volume") + icon("volume-muted") + "</button>" +
            '<div class="holy-reels-modal__card">' + s.cardHTML + "</div>" +
          "</div>";
      }).join("") +
      "</div>";
    document.body.appendChild(overlay);
    document.body.classList.add(OPEN);

    var track = overlay.querySelector(".holy-reels-modal__track");
    var slideEls = overlay.querySelectorAll(".holy-reels-modal__slide");

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target.querySelector("video");
        if (!v) return;
        if (e.isIntersecting && e.intersectionRatio > 0.6) v.play().catch(function () {});
        else v.pause();
      });
    }, { root: track, threshold: [0, 0.6, 1] });

    slideEls.forEach(function (s) {
      io.observe(s);
      var v = s.querySelector("video");
      var bar = s.querySelector(".holy-reels-modal__progress i");
      if (v && bar) v.addEventListener("timeupdate", function () { if (v.duration) bar.style.width = (v.currentTime / v.duration) * 100 + "%"; });
      var snd = s.querySelector(".holy-reels-modal__sound");
      if (snd && v) snd.addEventListener("click", function (ev) {
        ev.stopPropagation();
        v.muted = !v.muted;
        snd.dataset.sound = v.muted ? "off" : "on";
      });
    });

    function close() {
      io.disconnect();
      overlay.remove();
      document.body.classList.remove(OPEN);
      document.removeEventListener("keydown", onKey);
    }
    overlay.querySelector(".holy-reels-modal__close").addEventListener("click", close);
    function onKey(e) { if (e.key === "Escape") close(); }
    document.addEventListener("keydown", onKey);

    if (startIndex > 0 && slideEls[startIndex]) slideEls[startIndex].scrollIntoView();
  }

  function wire() {
    document.querySelectorAll('.holy-reels[data-fullscreen="true"]').forEach(function (section) {
      section.addEventListener("click", function (e) {
        var wrap = e.target.closest(".holy-reels__video-wrap");
        if (!wrap || e.target.closest(".wt-video__sound-toggle")) return;
        e.preventDefault();
        var slides = buildSlides(section);
        if (!slides.length) return;
        var card = wrap.closest(".holy-reels__card");
        var id = card ? card.getAttribute("data-block-id") : "";
        var idx = 0;
        for (var i = 0; i < slides.length; i++) { if (slides[i].id === id) { idx = i; break; } }
        openModal(slides, idx);
      });
    });
  }

  if (document.readyState !== "loading") wire();
  else document.addEventListener("DOMContentLoaded", wire);
})();
